(function(){
  const root=document.documentElement;
  root.classList.add('fh-theme');
  const reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-fh-hero-slideshow]').forEach(section=>{
    const slides=[...section.querySelectorAll('.fh-hero__slide')];
    const dots=[...section.querySelectorAll('[data-fh-slide-dot]')];
    if(slides.length<2) return;
    let active=0, timer;
    const spacer=section.querySelector('[data-fh-hero-copy-spacer]');
    const kicker=section.querySelector('[data-fh-hero-kicker]');
    const heading=section.querySelector('[data-fh-hero-heading]');
    const text=section.querySelector('[data-fh-hero-text]');
    const spacerKicker=section.querySelector('[data-fh-hero-spacer-kicker]');
    const spacerHeading=section.querySelector('[data-fh-hero-spacer-heading]');
    const spacerText=section.querySelector('[data-fh-hero-spacer-text]');
    const btn=section.querySelector('[data-fh-hero-button]');
    const btn2=section.querySelector('[data-fh-hero-button-2]');
    const setText=(el,value,forceHidden)=>{ if(!el) return; el.textContent=value||''; el.hidden=!!forceHidden||!value; };
    const setLink=(el,label,href)=>{ if(!el) return; el.textContent=label||''; el.hidden=!label; if(href) el.setAttribute('href',href); };
    const updateContent=(slide)=>{
      if(!slide) return;
      const hideCopy=slide.dataset.fhHideCopy==='true';
      const finishedArt=slide.dataset.fhFinishedArt==='true';
      section.classList.toggle('fh-hero--hide-copy',hideCopy);
      section.classList.toggle('fh-hero--finished-art',finishedArt);
      if(spacer) spacer.hidden=!hideCopy;
      setText(kicker,slide.dataset.fhKicker||'',hideCopy);
      setText(heading,slide.dataset.fhHeading||'',hideCopy);
      setText(text,slide.dataset.fhText||'',hideCopy);
      setText(spacerKicker,slide.dataset.fhKicker||'',false);
      setText(spacerHeading,slide.dataset.fhHeading||'',false);
      setText(spacerText,slide.dataset.fhText||'',false);
      setLink(btn,slide.dataset.fhButtonLabel||'',slide.dataset.fhButtonLink||'');
      setLink(btn2,slide.dataset.fhButton2Label||'',slide.dataset.fhButton2Link||'');
    };
    const show=(i)=>{active=(i+slides.length)%slides.length;slides.forEach((s,idx)=>s.classList.toggle('is-active',idx===active));dots.forEach((d,idx)=>d.classList.toggle('is-active',idx===active));updateContent(slides[active]);};
    const stop=()=>{ if(timer) window.clearInterval(timer); };
    const start=()=>{ if(reduce) return; stop(); timer=window.setInterval(()=>show(active+1),6500); };
    dots.forEach((dot,i)=>dot.addEventListener('click',()=>{show(i);start();}));
    updateContent(slides[active]);
    section.addEventListener('mouseenter',stop);section.addEventListener('mouseleave',start);start();
  });

  if(!reduce && window.innerWidth>989){
    const parallaxEls=[...document.querySelectorAll('[data-fh-parallax]')];
    const footerParallax=[];
    let ticking=false;
    function update(){
      const y=window.scrollY||0;
      parallaxEls.forEach(el=>{const speed=parseFloat(el.dataset.fhParallax||'0.035');el.style.transform='translate3d(0,'+(y*speed)+'px,0)';});
      footerParallax.forEach(el=>{
        const rect=el.getBoundingClientRect();
        const progress=(window.innerHeight-rect.top)/(window.innerHeight+rect.height);
        const clamped=Math.max(0,Math.min(1,progress));
        const offset=(clamped-.5)*54;
        el.style.setProperty('--fh-footer-parallax', offset.toFixed(2)+'px');
      });
      ticking=false;
    }
    if(parallaxEls.length){window.addEventListener('scroll',()=>{if(!ticking){requestAnimationFrame(update);ticking=true;}},{passive:true}); update();}
  }

  if(!reduce && 'IntersectionObserver' in window){
    const els=[...document.querySelectorAll('.fh-reveal,.fh-tile,.fh-product-card,.fh-accessory,.fh-featured-panel,.fh-community__shot,.fh-section__head')];
    const obs=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('fh-revealed');obs.unobserve(entry.target);}});},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
    els.forEach(el=>obs.observe(el));
  }

  document.querySelectorAll('[data-fh-back-top]').forEach(btn=>btn.addEventListener('click',()=>window.scrollTo({top:0,behavior:reduce?'auto':'smooth'})));
})();
